module.exports = __webpack_public_path__ + "caca84ccb035f9448c43a083c236ccaf.svg";